import { Component, ElementRef, OnInit, ViewChild } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms'
import { HttpErrorResponse } from '@angular/common/http'
import { CallerService } from '../services/caller.service'

type ResetPasswordStatus = 'form' | 'success' | 'error'

function passwordsMatchValidator(): ValidatorFn {
    return (group: AbstractControl): ValidationErrors | null => {
        const password = group.get('password')?.value
        const confirmPassword = group.get('confirmPassword')?.value
        return password === confirmPassword ? null : { mismatch: true }
    }
}

@Component({
    selector: 'app-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.css'],
})
export class ResetPasswordComponent implements OnInit {
    @ViewChild('passwordInput') passwordInput!: ElementRef
    @ViewChild('confirmPasswordInput') confirmPasswordInput!: ElementRef

    status: ResetPasswordStatus = 'form'
    message: string = ''
    isSubmitting: boolean = false
    passwordInputIcon: string = 'visibility'
    confirmPasswordInputIcon: string = 'visibility'

    private token: string = ''

    resetForm = new FormGroup({
        password: new FormControl('', [Validators.required, Validators.minLength(6)]),
        confirmPassword: new FormControl('', [Validators.required, Validators.minLength(6)]),
    }, { validators: passwordsMatchValidator() })

    constructor(
        private route: ActivatedRoute,
        private callerService: CallerService,
    ) {}

    ngOnInit(): void {
        const token = this.route.snapshot.queryParamMap.get('token')

        if (!token) {
            this.status = 'error'
            this.message = 'This reset link is missing its token.'
            return
        }

        this.token = token
    }

    submit(): void {
        if (this.resetForm.invalid) {
            return
        }

        this.isSubmitting = true

        this.callerService.resetPassword(this.token, this.resetForm.value.password ?? '').subscribe({
            next: (res: any) => {
                this.isSubmitting = false
                this.status = 'success'
                this.message = res?.body?.message ?? 'Your password has been reset.'
            },
            error: (err: HttpErrorResponse) => {
                this.isSubmitting = false
                this.status = 'error'
                this.message = err?.error?.message ?? 'This reset link is invalid or has expired.'
            },
        })
    }

    togglePasswordInputIcon(): void {
        if (this.passwordInputIcon == 'visibility') {
            this.passwordInputIcon = 'visibility_off'
            this.passwordInput.nativeElement.type = 'text'
        } else {
            this.passwordInputIcon = 'visibility'
            this.passwordInput.nativeElement.type = 'password'
        }
    }

    toggleConfirmPasswordInputIcon(): void {
        if (this.confirmPasswordInputIcon == 'visibility') {
            this.confirmPasswordInputIcon = 'visibility_off'
            this.confirmPasswordInput.nativeElement.type = 'text'
        } else {
            this.confirmPasswordInputIcon = 'visibility'
            this.confirmPasswordInput.nativeElement.type = 'password'
        }
    }
}
